import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteLoanIncomeParams {
  loanId: string;
  incomeId: string;
}

const deleteLoanIncome: MutationFunction<
  boolean,
  DeleteLoanIncomeParams
> = async ({ loanId, incomeId }) => {
  if (isMockServices()) return await mock(true);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/loans/${loanId}/incomes/${incomeId}`,
    { method: 'DELETE' },
  );

  if (response.data) return response.data.success;
  throw new Error('Failed to delete income');
};

export default deleteLoanIncome;
